//otwieranie oraz zamykanie modala z listą nauczycieli
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';

export type NotificationTypes = 'success' | 'error' | 'info' | 'warning';
export type NotificationData = {
  notifType: NotificationTypes;
  titleTranslationKey: string;
  bodyTranslationKey: string;
  duration?: number;
  code?: string | number;
};
export interface ShowNotification {
  type: typeof SHOW_NOTIFICATION;
  payload: NotificationData;
}

//interface stora
export interface AppConfigState {
  mainNavPanel: {
    opened: boolean;
  };
}

export type utilityActionTypes =
  ShowNotification;
